class User {
  /**
   * Create the instance with the response.data as returned by the API
   * GET /<VERSION>/users
   * @param data
   */
  constructor(data) {
    this.id = data.id;
    this.name = '';
    this.roles = data.roles;
    this.email = data.email;
  }

  /**
   * Is this user a Super Admin?
   *
   * @returns {boolean}
   */
  isSuperAdmin() {
    for (let i = 0; i < this.roles.length; i += 1) {
      if (this.roles[i].name === 'super_admin') {
        return true;
      }
    }

    return false;
  }

  /**
   * Is this user a Ignition Admin?
   *
   * @returns {boolean}
   */
  isIgnitionAdmin() {
    for (let i = 0; i < this.roles.length; i += 1) {
      if (this.roles[i].name === 'ignition_admin') {
        return true;
      }
    }

    return false;
  }

  /**
   * Is this user a client admin user?
   *
   * @returns {boolean}
   */
  isClientAdminUser() {
    for (let i = 0; i < this.roles.length; i += 1) {
      if (this.roles[i].name === 'client_admin') {
        return true;
      }
    }

    return false;
  }

  /**
   * Is this user a normal client user?
   *
   * @returns {boolean}
   */
  isClientUser() {
    for (let i = 0; i < this.roles.length; i += 1) {
      if (this.roles[i].name === 'client_user') {
        return true;
      }
    }
    return false;
  }
}

export default User;
